import { IOrder } from '../../../../../../../../app/entities/Order'

type OrderWithServices =
  | Pick<IOrder, 'orderServices'>
  | {
      orderServices?: Array<{
        price: number
        priceOverride?: number
        quantity: number
      }>
    }

/**
 * Returns the pre-tax subtotal for calculating percentage-based promotions
 * Calculates based on order services (line items)
 * Works with both IOrder from backend and OrderData from frontend
 */
export const getPreTaxSubtotal = (order: OrderWithServices): number => {
  // Calculate pre-tax total from order services directly
  if (Array.isArray(order.orderServices) && order.orderServices.length > 0) {
    let total = 0
    for (const service of order.orderServices) {
      // Use priceOverride if available, otherwise use regular price
      const servicePrice =
        typeof service.priceOverride === 'number'
          ? service.priceOverride
          : service.price

      if (
        typeof servicePrice === 'number' &&
        typeof service.quantity === 'number'
      ) {
        total += servicePrice * service.quantity
      }
    }

    if (total > 0) {
      return total
    }
  }

  return 0
}
